import React from 'react';
import BulkActionsListContainer from './containers/bulk-actions-list/bulk-actions-list.container';

export const BulkActionsModule: React.FC = () => {
  return <BulkActionsListContainer />;
};
